export enum AUTHOR_ROLE {
    USER = "user",
    ASSISTANT = "assistant",
    ERROR = "error",
    DEVELOPER = "developer",
    SYSTEM = "system",
    TOOL = "tool",
}